module.exports = __webpack_public_path__ + "static/media/hand-spock.bf6e5b80.svg";